import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { SiteFooter } from "@/components/PublicLayout";
import { CONTACT_PHONE, CONTACT_EMAIL, CONTACT_WHATSAPP_LINK } from "@/lib/aps";

export function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <Header />
      <article className="max-w-3xl mx-auto px-6 py-14">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Legal</p>
        <h1 className="font-display text-4xl font-bold text-[#0B2447] mt-2">{title}</h1>
        <p className="text-slate-400 text-sm mt-2">Last updated: {updated}</p>
        <div className="prose prose-slate mt-8 space-y-6 text-slate-700 leading-relaxed">{children}</div>
        <div className="mt-12 pt-8 border-t border-slate-200 text-sm text-slate-500">
          <p className="mb-3">
            Questions? Message us on WhatsApp (text only) at{" "}
            <a href={CONTACT_WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="text-[#0B2447] font-semibold">{CONTACT_PHONE}</a>{" "}
            or email{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#0B2447] font-semibold break-all">{CONTACT_EMAIL}</a>.
          </p>
          <Link to="/terms" className="underline mr-6">Terms & Conditions</Link>
          <Link to="/privacy" className="underline">Privacy Policy</Link>
        </div>
      </article>
      <SiteFooter />
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-display text-xl font-bold text-[#0B2447] mt-8">{children}</h2>;
}
